import { useState } from "react"
import { Button } from "@/components/ui/button"
import { ArrowLeft, Eye } from "lucide-react"
import { toast } from "sonner"

import { switchToOrganization } from "../actions/account-switch-actions"
import { useIsCrmScoped, useUserOrganizations } from "../hooks/use-organization-access"
import { useAuth } from "../hooks/useAuth"

export function CrmScopeBanner() {
  const isCrmScoped = useIsCrmScoped()
  const { user } = useAuth()
  const { data: userOrganizations } = useUserOrganizations()
  const [isReturning, setIsReturning] = useState(false)

  if (!isCrmScoped) return null

  const activeOrganization = userOrganizations?.find(
    organization => organization.id === user?.organization_id
  )
  const ownedOrganization = userOrganizations?.find(
    organization => organization.access_scope === "full"
  )
  const organizationName = activeOrganization?.name ?? "compartilhada"

  const handleReturnToOwnedOrganization = async () => {
    if (!ownedOrganization || isReturning) return
    setIsReturning(true)
    try {
      await switchToOrganization(ownedOrganization.id, "full")
    } catch {
      setIsReturning(false)
      toast.error("Erro ao voltar para sua conta")
    }
  }

  return (
    <div className="flex items-center justify-center gap-2 border-b border-amber-300 bg-amber-50 px-4 py-1.5 text-sm text-amber-800">
      <Eye className="h-4 w-4 shrink-0" />
      <span className="truncate">Visualizando conta {organizationName}</span>
      <span aria-hidden>-</span>
      <Button
        variant="link"
        size="sm"
        className="h-auto gap-1 p-0 text-amber-800 underline"
        onClick={handleReturnToOwnedOrganization}
        disabled={!ownedOrganization || isReturning}
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        Voltar para minha conta
      </Button>
    </div>
  )
}
